import { useIntl } from "react-intl"
import { useRef, useState, useEffect } from "react"
import { Modal } from "medere-ui-framework"
import {acceptPatientTransferWhitPhone, getPatientTransferById} from "../services/TransferController"
import { Toast } from 'primereact/toast';
import { TransferRequestCard } from "../components/InfoCard/TransferRequestCard";
import { useSearchParams } from "react-router";

export enum TransferStatus {
    PENDING = 1,
    INPROGRESS = 2,
    FINISHED = 3,
    CANCELLED = 4
}

export default function StretcherBearerRequestView() {

    const [searchParams] = useSearchParams();
  
    const patientTransfer: number = Number(searchParams.get('patienttransfer'));
    const stretcherBearerPhone: number = Number(searchParams.get('stretcherbearerphone')); 
    const userId: number = Number(searchParams.get('userID')); 

    type PatientTransferDTO = { patienttransfer: number, fullname: string, namenewsector: string, namecurrentsector: string, currentsector: number, conveyance: string, oxygen: boolean, priority: number, prioritydescription: string, currentstatus: number, observations: string, toroomnumber: string, tobednumber: string, fromroomnumber: string, frombednumber: string, _userstretbearer: number, stretbearerfullname: string, clinichistoryid: string, userfullname: string, requestedtime: Date }

    const intl = useIntl()
    const [open, setOpen] = useState(true)
    const [requestAcceptedByUser, setRequestAcceptedByUser] = useState(false)
    const [requestAlreadyInProgress, setRequestAlreadyInProgress] = useState(false)
    const toast = useRef(null);

    const [patientTransferData, setPatientTransferData] = useState<PatientTransferDTO>();

    const loadPatientTransferData = async () => {
        try {
            const response = await getPatientTransferById(patientTransfer);
            console.log("response: ",response)
            //if (response && response.data) {
                const values: PatientTransferDTO = {
                    fullname: response.fullname,
                    conveyance: response.conveyance,
                    currentsector: response.currentsector,
                    currentstatus: response.currentstatus,
                    namecurrentsector: response.namecurrentsector,
                    namenewsector: response.namenewsector,
                    observations: response.observations,
                    oxygen: response.oxygen,
                    patienttransfer: response.patienttransfer,
                    priority: response.priority,
                    prioritydescription: response.prioritydescription,
                    tobednumber: response.tobednumber,
                    toroomnumber: response.toroomnumber,
                    fromroomnumber: response.fromroomnumber,
                    frombednumber: response.frombednumber,
                    _userstretbearer: response._userstretbearer,
                    stretbearerfullname: response.stretbearerfullname,
                    clinichistoryid: response.clinichistoryid,
                    userfullname: response.userfullname,
                    requestedtime: response.requestedtime,
                };
                if (values.currentstatus != TransferStatus.PENDING)
                    setRequestAlreadyInProgress(true)
                setPatientTransferData(values);
                console.log("patientTransferData: ",patientTransferData)
            //}
            console.log("ya sali del if, data:", patientTransferData)
        } catch (error) {
            console.error('Error al cargar los datos del paciente transferido:', error);
        }
    };

    useEffect(() => {
        console.log("entro al useEffect")
        loadPatientTransferData();
        console.log("salgo del useEffect")
    }, []);    
    function accept() {
        if (patientTransfer && userId && stretcherBearerPhone) {
            if (patientTransferData?.currentstatus === TransferStatus.PENDING){
                acceptPatientTransferWhitPhone(patientTransfer, stretcherBearerPhone)
                .then((msgError) => {
                    if (msgError.statusCode == 208){
                        setRequestAlreadyInProgress(true)
                    }else{
                        setRequestAcceptedByUser(true)
                    }
                    setTimeout(function() {
                        window.close(); //o window.history.back
                    }, 2000);
                })
                .catch(error => {
                    console.error('Error al guardar los datos:', error);
                })
            }
        }else{
            console.error('pattienttransfer or userId undefined');
        }

    }

    return (
        <div className="m-4 viewContainer">
            <Modal visible={open} setVisible={setOpen} header={intl.formatMessage({ id: 'TransferRequest' })} className="custom-modal" onClickRightBtn={accept} footerButtonRightText={!requestAcceptedByUser && !requestAlreadyInProgress ? intl.formatMessage({id: "Accept"}):undefined}>
                {
                    !requestAcceptedByUser && 
                    !requestAlreadyInProgress && 
                    <div className="flex flex-col gap-2">
                        {patientTransferData && (<TransferRequestCard
                        key={patientTransfer}
                        record={patientTransferData}
                        userId={userId}
                        details
                    />)} 
                    </div>
                }
                {
                    requestAcceptedByUser && 
                    <div className="flex flex-col gap-2">
                        <p><strong>{intl.formatMessage({ id: 'RequestAccepted' })}</strong> </p>
                    </div>
                }
                {
                    requestAlreadyInProgress && 
                    <div className="flex flex-col gap-2">
                        <p><strong>{intl.formatMessage({ id: 'RequestAlreadyInProgress' })}</strong> </p>
                    </div>
                }
            </Modal>
            
            <Toast ref={toast} position="bottom-right" />

        </div>
    )
    
}

/*<p><strong>{intl.formatMessage({ id: 'Patient' })}:</strong> {patientTransferData ? patientTransferData.fullname : 'Cargando...'}</p>
                        <p><strong>{intl.formatMessage({ id: 'Origin' })}:</strong> {patientTransferData ? patientTransferData.namecurrentsector : 'Cargando...'}</p>
                        {(patientTransferData ? patientTransferData.fromroomnumber : null) && (<p><strong>{intl.formatMessage({ id: 'OriginRoom' })}:</strong> {patientTransferData ? patientTransferData.fromroomnumber : 'Cargando...'}</p>)}
                        {(patientTransferData ? patientTransferData.frombednumber : null) && (<p><strong>{intl.formatMessage({ id: 'OriginBed' })}:</strong> {patientTransferData ? patientTransferData.frombednumber : 'Cargando...'}</p>)}
                        <p><strong>{intl.formatMessage({ id: 'Destiny' })}:</strong> {patientTransferData ? patientTransferData.namenewsector : 'Cargando...'}</p>
                        {(patientTransferData ? patientTransferData.toroomnumber : null) && (<p><strong>{intl.formatMessage({ id: 'DestinyRoom' })}:</strong> {patientTransferData ? patientTransferData.toroomnumber : 'Cargando...'}</p>)}
                        {(patientTransferData ? patientTransferData.tobednumber : null) && (<p><strong>{intl.formatMessage({ id: 'DestinyBed' })}:</strong> {patientTransferData ? patientTransferData.tobednumber : 'Cargando...'}</p>)}
                        <p><strong>{intl.formatMessage({ id: 'Priority' })}:</strong> {patientTransferData ? patientTransferData.prioritydescription : 'Cargando...'}</p>
                        <p><strong>{intl.formatMessage({ id: 'conveyance' })}:</strong> {patientTransferData ? patientTransferData.conveyance : 'Cargando...'}</p>
                        {(patientTransferData ? patientTransferData.oxygen : false) && (<div>
                            <strong>{intl.formatMessage({ id: 'Oxygen' })}: </strong> {intl.formatMessage({ id: 'Yes' })}
                        </div>)}
                        {(patientTransferData ? patientTransferData.observations : null) && (<p><strong>{intl.formatMessage({ id: 'Observations' })}:</strong> {patientTransferData ? patientTransferData.observations : 'Cargando...'}</p>)}*/